import styled from 'styled-components'

const AppWrapper = styled.div`
  padding-bottom: 85px;
  background-color: ${({ theme }) => theme.backgroundColour};
  color: ${({ theme }) => theme.primaryTextColour};
  ${
    '' /* Apply a colour to all child anchors without increasing specificicity with a css class */
  }
  *:where(&) a {
    color: ${({ theme }) => theme.linkColour};
    outline-color: ${({ theme }) => theme.linkFocusOutlineColour};
  }
  body:has(&) {
    background-color: ${({ theme }) => theme.backgroundColour};
  }
`

export default AppWrapper
